import { LoggedOut } from "@memberstack/react"
import App from "../../App"
import GlobalLoader from "./GlobalLoader";
import { useEffect } from "react";


const Logout = ()=>{

    useEffect(()=>{

        
    },[])
return (
<LoggedOut fallback={<GlobalLoader/>}>
 
</LoggedOut>)
}
export default Logout;